import { Alert } from 'antd';

import { ClassicLink } from './ClassicLink';

export interface ComingSoonProps {
  children?: React.ReactNode;
  className?: string;
  classicPath?: string;
}

export function ComingSoon({
  children,
  className,
  classicPath,
}: ComingSoonProps) {
  return (
    <>
      <Alert
        className={className}
        type="info"
        showIcon
        message={'Coming soon!'}
        description={
          <>
            {children ?? 'This content is temporarily unavailable.'}
            {classicPath && (
              <p>
                <ClassicLink classicPath={classicPath} />
              </p>
            )}
          </>
        }
        style={{ maxWidth: 600, margin: '0 auto', textAlign: 'center' }}
      />
    </>
  );
}
